<template>
  <div id="cloudLog">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>设备</el-breadcrumb-item>
          <el-breadcrumb-item>设备管理</el-breadcrumb-item>
          <el-breadcrumb-item>平台日志</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true"
               style="height: 42px;"
               label-width="80px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="客户::">
              <el-select v-model="pageSearch.fCustID"
                         filterable
                         placeholder="请选择客户"
                         :clearable="true"
                         style="width:200px;">
                <el-option v-for="item in cust_list"
                           :key="item.fCustID"
                           :label="item.unionName"
                           :value="item.fCustID">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开始时间::">
              <el-date-picker v-model="startTime"
                              style="width:200px"
                              type="datetime"
                              :clearable="true"
                              format="yyyy-MM-dd HH:mm:ss"
                              placeholder="选择开始时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间::">
              <el-date-picker v-model="endTime"
                              style="width:200px"
                              :clearable="true"
                              format="yyyy-MM-dd HH:mm:ss"
                              type="datetime"
                              placeholder="选择结束时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="操作人::">
              <el-input placeholder="请输入操作员"
                        v-model="pageSearch.fUsrNo"
                        class="search">
              </el-input>
            </el-form-item>
            <el-form-item label="关键字::">
              <el-input placeholder="请输入关键字"
                        v-model="pageSearch.searchKeyWord"
                        class="search">
              </el-input>
            </el-form-item>
            <el-form-item label="">
              <el-button type="primary"
                         size="small"
                         icon="el-icon-search"
                         @click="page_list">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           type="index"
                           :index="indexMethod"
                           align="right"
                           label="序号">
          </el-table-column>
          <el-table-column prop="fCustName"
                           label="客户"
                           width="150">
          </el-table-column>
          <el-table-column prop="fOpLastTime"
                           label="操作时间"
                           width="160">
          </el-table-column>
          <el-table-column prop="fOpUserName"
                           width="200"
                           label="操作人">
          </el-table-column>
          <el-table-column prop="fModName"
                           width="120"
                           label="模块">
          </el-table-column>
          <el-table-column prop="fIPAddr"
                           width="120"
                           label="IP">
          </el-table-column>
          <el-table-column prop="fFunName"
                           width="120"
                           label="功能">
          </el-table-column>
          <el-table-column prop="fRemark"
                           label="备注">
          </el-table-column>
          <!-- <el-table-column label="备注">
            <template slot-scope="scope">
              <el-tooltip placement="top">
                <div slot="content"
                     v-html="scope.row.fRemark"></div>
                <span>{{scope.row.fRemark}}</span>
              </el-tooltip>
            </template>
          </el-table-column> -->
          <el-table-column label="操作"
                           fixed="right"
                           align="center"
                           width="80">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="success"
                         @click="handleInfo(scope.$index, scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog :title="dialogTitle"
               top="7vh"
               width="40%"
               v-dialogDrag
               :visible.sync="dialogFormVisible">
      <el-form ref="ruleForm"
               label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="操作时间::">
              <el-input v-model="form.fOpLastTime"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="操作时间::">
              <el-input v-model="form.fOpUserName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="IP地址::">
              <el-input v-model="form.fIPAddr"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户名称::">
              <el-input v-model="form.fCustName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="系统名称::">
              <el-input v-model="form.fSysName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="模块名称::">
              <el-input v-model="form.fModName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="功能名称::">
              <el-input v-model="form.fFunName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="fRemark_row">
          <el-col :span="24">
            <el-form-item label="备注::">
              <el-input type="textarea"
                        v-model="form.fRemark"
                        id="fRemark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="fRemark_row">
          <el-col :span="24">
            <el-form-item label="操作内容::">
              <el-input type="textarea"
                        v-model="form.fExeMemo"
                        id="fRemark1"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="dialog-footer"
           slot="footer">

        <el-button @click="dialogFormVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { device } from '../../api/device'
import * as park from '../../api/park'
// import * as user from '../../api/user'
export default {
  name: 'channelLogMain.vue',
  data () {
    return {
      dialogTitle: '查看日志详情',
      dialogFormVisible: false,
      form: {},
      is_export: false,
      pageData: [],
      cust_list: [],
      loading: false,
      tableHeight: 0,
      pageCount: 0,
      pageSearch: {
        pageIndex: 1,
        pageSize: 20,
        fUsrNo: '',
        fCustID: '',
        fStartTime: '',
        fEndTime: '',
        searchKeyWord: ''
      },
      startTime: '',
      endTime: ''
    }
  },
  methods: {
    initData () {
      this.pageSearch.pageIndex = 1
      this.pageSearch.fStartTime = ''
      if ((this.startTime || '').toString().trim().length > 0) {
        this.pageSearch.fStartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm:ss')
      }
      this.pageSearch.fEndTime = ''
      if ((this.endTime || '').toString().trim().length > 0) {
        this.pageSearch.fEndTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm:ss')
      }
    },
    page_list (index) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      this.loading = true
      this.pageSearch.fStartTime = ''
      if ((this.startTime || '').toString().trim().length > 0) {
        this.pageSearch.fStartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm:ss')
      }
      this.pageSearch.fEndTime = ''
      if ((this.endTime || '').toString().trim().length > 0) {
        this.pageSearch.fEndTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm:ss')
      }
      device.cloudPageList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data
            this.pageCount = data.Data.count
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    handleInfo (index, row) {
      this.form = row
      this.dialogFormVisible = true
    },
    init () {
      var today = new Date()
      this.startTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
      this.endTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
      park.getCustByGroup().then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data || []
            // if (this.cust_list && this.cust_list.length > 0) {
            //   this.pageSearch.fCustID = this.cust_list[0].fCustID
            //   this.loadPark(this.pageSearch.fCustID)
            // }
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.page_list(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.page_list(val)
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.fBatchID === '1') {
        return 'warning-row'
      }
      return ''
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 210
      obj.tableHeight = clientHeight
    }
  },
  created () {
    // user.getCurrentUserPers({ perTypeId: 72000 }).then(res => {
    //   if (res && res.data) {
    //     var data = res.data
    //     if (data.IsOk) {
    //       if (data.Data) {
    //         this.is_export = data.Data.data.is_export
    //       }
    //     } else {
    //       this.$message.error('提示：加载当前用户权限信息失败')
    //     }
    //   }
    // })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.init()
    this.initData()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>

<style>
/* dialog弹出框样式 */
#cloudLog .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#cloudLog .el-dialog__title {
  color: white;
}
#cloudLog .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#cloudLog .el-dialog__body {
  padding: 30px 20px 0px 20px;
}
#cloudLog .is-disabled .el-input__inner,
#cloudLog .is-disabled .el-textarea__inner {
  color: #606266;
}
#cloudLog #fRemark,
#cloudLog #fRemark1 {
  height: 180px;
}
#cloudLog .fRemark_row .el-form-item__content {
  height: 180px;
}
</style>
<style scoped>
.el-form-item {
  margin-bottom: 10px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 200px;
}
.tip {
  text-align: center;
  position: absolute;
  top: 12px;
  right: 40px;
}
.log_search {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/device/cloudLog.vue